// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { ImageLargeFragmentDoc } from '../imageLarge.fragment.generated';
export const ComponentLogosCarouselFragmentDoc = gql`
    fragment componentLogosCarousel on ComponentLogosCarousel {
  logos {
    image {
      ...imageLarge
    }
    link
  }
}
    ${ImageLargeFragmentDoc}`;